import BoringAvatar from "boring-avatars";
import { cn } from "@/lib/utils";

/** Deterministic palette for generated avatars (brand-aligned). */
const AVATAR_COLORS = ["#10b981", "#0ea5e9", "#8b5cf6", "#f59e0b", "#ec4899"];

export interface AvatarProps {
  /** stable seed — a handle, name, or id (same seed → same avatar) */
  name: string;
  /** optional real image; falls back to a generated avatar on error/absence */
  src?: string | null;
  size?: number;
  className?: string;
  variant?: "beam" | "marble" | "bauhaus" | "sunset" | "ring" | "pixel";
}

/** Avatar with an image when available, else a stable generated "boring" avatar.
 *  Used for collaboration creators and the user menu — never a broken image. */
export function Avatar({ name, src, size = 36, className, variant = "beam" }: AvatarProps) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        draggable={false}
        className={cn("shrink-0 rounded-full object-cover ring-1 ring-black/5 dark:ring-white/10", className)}
        onError={(e) => {
          // swap to the generated fallback by hiding the broken image
          (e.currentTarget as HTMLImageElement).style.display = "none";
        }}
      />
    );
  }
  return (
    <span className={cn("inline-flex shrink-0 overflow-hidden rounded-full ring-1 ring-black/5 dark:ring-white/10", className)}>
      <BoringAvatar size={size} name={name || "prado"} variant={variant} colors={AVATAR_COLORS} />
    </span>
  );
}
